module.exports = __webpack_public_path__ + "img/button_volna_an.bb32c946.svg";